import Vue from 'vue'
import Modal from './components/Modal'
import Retro from './components/Retro'
import Devolver from './components/Devolver'
import Rating from './components/Rating'

import 'normalize.css'
import '../src/styles/main.scss'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  components: {Modal, Retro, Devolver, Rating},
  data() {
    return {
      showModal: false,
      showRetro: false
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js